import React, { useState } from "react";

import StudentPendingJobsGreen from "./StudentPendingJobsGreen";
import StudentLiveJobsGreen from "./StudentLiveJobsGreen";
import StudentJobApplication from "./StudentJobApplication";
import StudentSelectedTutor from "./StudentSelectedTutor";
import StudentAppointmentTutors from "./StudentAppointmentTutors";

const StudentDashGreen = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <StudentPendingJobsGreen></StudentPendingJobsGreen>;
      case 1:
        return <StudentLiveJobsGreen></StudentLiveJobsGreen>;
      case 2:
        return <StudentJobApplication></StudentJobApplication>;
      case 3:
        return <StudentSelectedTutor></StudentSelectedTutor>;
      case 4:
        return <StudentAppointmentTutors></StudentAppointmentTutors>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-100">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          Dashboard
        </h2>
      </div>
      <div className="m-5 flex flex-row gap-5">
        <button
          onClick={() => setActiveTab(0)}
          className={activeTab === 0 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Pending Jobs
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={activeTab === 1 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Live Jobs
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={activeTab === 2 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Job Applicants
        </button>
        <button
          onClick={() => setActiveTab(3)}
          className={activeTab === 3 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Selected Tutors
        </button>
        <button
          onClick={() => setActiveTab(4)}
          className={activeTab === 4 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Appointment Tutors
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default StudentDashGreen;
